import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import 'amfe-flexible'
// import './utils/rem'


createApp(App).use(router).mount('#app')
